function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React, { Fragment } from 'react';
import { withTheme } from 'styled-components';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { Button } from '@finect/tabular-core/Button';
import { Link } from 'react-router-dom';
import { QuestionCardList } from '../QuestionCardList';
import { QuestionRelatedList } from '../QuestionRelatedList';
import { Loading } from '../../Loading';
import { Inner, MoreButton, ContentBlock, Aside, Content, EmptyResults } from '../../Reviews/ReviewsBlock/partials';
import { NoResultsPlaceholder } from '../NoResultsPlaceholder';
import { NoResults } from './partials';
import { getQuestionsPath } from './../utils';
import { PlaceholderQuestionsIcon } from './icons';
export var QuestionsBlock = function (_React$Component) {
  _inherits(QuestionsBlock, _React$Component);
  var _super = _createSuper(QuestionsBlock);
  function QuestionsBlock() {
    _classCallCheck(this, QuestionsBlock);
    return _super.apply(this, arguments);
  }
  _createClass(QuestionsBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        theme = _this$props.theme,
        me = _this$props.me,
        qty = _this$props.qty,
        showMoreButton = _this$props.showMoreButton,
        finectApp = _this$props.finectApp,
        product = _this$props.product,
        tag = _this$props.tag;
      var path = getQuestionsPath(theme, product, tag);
      var displayQuestions = this.props.questions ? this.props.questions.items.slice(0, qty) : [];
      var fetching = false;
      var moreLinkProps = ['front-products'].includes(finectApp) && path.pattern.match ? {
        to: path.path,
        as: Link
      } : {
        href: path.superPartnerURL,
        as: 'a'
      };
      if (displayQuestions.length === 0) {
        return React.createElement(Inner, null, React.createElement(NoResultsPlaceholder, {
          product: this.props.product,
          link: {
            'data-fi-event': 'productQuestions-question',
            href: "/preguntas/nueva-pregunta?product=".concat(this.props.product.id),
            text: 'Escribe tu pregunta'
          },
          text: React.createElement("span", null, "Este producto a\xFAn no ha recibido ninguna pregunta. ", React.createElement("b", null, "S\xE9 el primero en escribir"), " la tuya para ayudar al resto de usuarios a tomar mejores decisiones financieras."),
          icon: PlaceholderQuestionsIcon
        }));
      }
      return React.createElement(Inner, null, React.createElement(ContentBlock, null, !this.props.asideHidden ? React.createElement(Aside, null, React.createElement(Paragraph, null, "Preguntas destacadas"), React.createElement(QuestionRelatedList, {
        questions: displayQuestions
      })) : null, React.createElement(Content, {
        centered: displayQuestions.length === 0
      }, fetching ? React.createElement(Fragment, null, React.createElement(Loading, null)) : React.createElement(Fragment, null, displayQuestions.length ? React.createElement(QuestionCardList, {
        me: me,
        questions: displayQuestions
      }) : React.createElement(EmptyResults, null, React.createElement("div", null, React.createElement(Paragraph, null, "No hemos encontrado preguntas para ", React.createElement("strong", null, this.props.product.name)), React.createElement(Button, {
        as: "a",
        href: "https://www.finect.com/nueva-pregunta",
        rel: "nofollow",
        width: "auto"
      }, "Escribe tu pregunta"))), showMoreButton ? this.props.questions.items.length > qty ? React.createElement(MoreButton, _extends({
        width: "auto"
      }, moreLinkProps), "Ver todas las preguntas", React.createElement(ArrowRight, {
        size: 18,
        style: {
          verticalAlign: 'middle'
        }
      })) : React.createElement(NoResults, {
        light: true
      }, "No hay m\xE1s preguntas") : null))));
    }
  }]);
  return QuestionsBlock;
}(React.Component);
export default React.memo(withTheme(QuestionsBlock));